import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Button, ButtonGroup, Tooltip } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';

const TextDecorationWithState = ({ options = [] }) => {
  const { t } = useTranslation();

  const {
    actions: { setProp },
    fontWeight,
    textDecoration,
    fontItalic,
  } = useNode(({ data: { props } }) => {
    return {
      textAlign: props.textAlign,
      fontWeight: props.fontWeight,
      textDecoration: props.textDecoration,
      fontItalic: props.fontItalic,
    };
  });

  const fieldValue = {
    fontWeight,
    textDecoration,
    fontItalic,
  };

  const onClick = (event) => {
    const fieldName = event?.currentTarget?.name;

    setProp((props) => {
      props[fieldName] = !Boolean(fieldValue[fieldName]);
    }, 500);
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'bold':
        return <FormatBoldIcon />;
      case 'underline':
        return <FormatUnderlinedIcon />;
      case 'italic':
        return <FormatItalicIcon />;
      default:
        return null;
    }
  };

  return (
    <div style={{ display: 'block' }}>
      <ButtonGroup
        disableElevation
        sx={{ border: 'none' }}
        aria-label='Basic button group'
        size='small'
      >
        {options.map((option) => (
          <Tooltip key={option.name} title={t(option.label)}>
            <Button
              name={option.name}
              onMouseDown={(e) => e.preventDefault()}
              onClick={onClick}
              sx={(theme) => ({
                p: 1,
                '& span': {
                  m: 0,
                },
                backgroundColor: theme.palette.secondary.light,
                color: fieldValue[option.name]
                  ? theme.palette.secondary.dark
                  : theme.common.buttonInactive,
                border: `none`,
              })}
              startIcon={renderIcon(option.iconName)}
            />
          </Tooltip>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default TextDecorationWithState;
